import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { useMemo } from 'react';

export default function useLoadingHandler() {
  // #region Dependencies
  const fetching = useIsFetching({
    predicate: (query) => query.state.status === 'loading' && query.state.dataUpdateCount === 0,
  });

  const mutating = useIsMutating({
    predicate: (mutation) => mutation.meta?.shouldShowLoading ?? true,
  });
  // #endregion

  return useMemo(() => !!fetching || !!mutating, [fetching, mutating]);
}
